export default (value) => {
    return JSON.stringify(value, null, 4);
}